<section id="why-us" class="why-us">
  <div class="container">

    <header class="section-header">
      <h2>WHY TAGORE GLOBAL SCHOOL ?</h2>
      <!-- <p>BALANCED EDUCATION | WE UNLEASH HIDDEN TALENTS | QUALITY EDUCATION </p> -->
    </header>

    <div class="row">

      <div class="col-lg-6">


        <div class="why-us-img">
          <!-- ======= Portfolio Details Section ======= -->
          <section id="whyus-details" class="whyus-details">
            <div class="container">

              <div class="whyus-details-container">

                <div id="whyCarousel" class="carousel slide" data-bs-ride="carousel">
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <img src="/assets/img/achievers/shivam.png" class="img-fluid" alt="Best CBSE School in Haryana">
                    </div>
                    <div class="carousel-item active">
                      <img src="/assets/img/why/1.jpeg" class="img-fluid" alt="Best CBSE School in Haryana">
                    </div>
                    <div class="carousel-item">
                      <img src="/assets/img/why/2.jpeg" class="img-fluid" alt="Best CBSE School in Haryana">
                    </div>
                    <div class="carousel-item">
                      <img src="/assets/img/why/3.jpeg" class="img-fluid" alt="Best CBSE School in Haryana">
                    </div>
                    <div class="carousel-item">
                      <img src="/assets/img/why/4.jpeg" class="img-fluid" alt="Tagore Global School Kurukshetra">
                    </div>
                    <div class="carousel-item">
                      <img src="/assets/img/why/5.jpeg" class="img-fluid" alt="Tagore Global School Kurukshetra">
                    </div>
                    <div class="carousel-item">
                      <img src="/assets/img/why/6.jpeg" class="img-fluid" alt="Best CBSE School in Kurukshetra">
                    </div>
                  </div>
                </div>
              </div>





            </div>
          </section>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="why-us-content">

          <div class="features  clearfix " data-scroll>
            <i class="fa fa-diamond" style="color: #f058dc;"></i>
            <h4>Balanced Education</h4>
            <p> The Curriculum balances fun and innovative ways of learning with a structured
              programme that develops character, confidence and a Global perspective. Adapted to current Time, our
              specialist teachers open doors to the world
              of art,science,IT,quiz, music,dance,dramatics, sports, computing ,public speaking and more.</p>
          </div>

          <div class="features  clearfix" data-scroll>
            <i class="fa fa-object-group" style="color: #ffb774;"></i>
            <h4>We Unleash Hidden Talent</h4>
            <p> We understand that every child has potential and that it is the school's aim to inspire
              students to discover and pursue it. Our experienced &amp; learned faculty helps students to
              discover their own abilities.</p>
          </div>

          <div class="features  clearfix" data-scroll>
            <i class="fa fa-language" style="color: #589af1;"></i>
            <h4>Quality Education</h4>
            <p>Quality education aims at developing a balanced set of capabilities of children they
              require to become economically productive, develop sustainable livelihoods, contribute to
              peaceful and democratic societies and enhance individual well-being.We strongly discourage
              rote learning and encourage creativity.Making a strong foundation is our USP</p>
          </div>.

        </div>

      </div>

    </div>

  </div>


</section>